export const splitFormConfig = {
  targetStudy: {
    patient: {
      name: {
        lastName: {
          type: 'text',
          required: true,
          requiredWith: null,
          notRequiredWith: null,
          min: 2,
          max: 60,
          allowedChars: '.',
          section: 'A',
        },
        firstName: {
          type: 'text',
          required: false,
          requiredWith: null,
          notRequiredWith: null,
          min: 2,
          max: 60,
          allowedChars: '.',
          section: 'A',
        },
        middleName: {
          type: 'text',
          required: false,
          requiredWith: null,
          notRequiredWith: null,
          min: 2,
          max: 60,
          allowedChars: '.',
          section: 'A',
        },
        prefix: {
          type: 'text',
          required: false,
          requiredWith: null,
          notRequiredWith: null,
          min: 2,
          max: 60,
          allowedChars: '.',
          section: 'A',
        },
        suffix: {
          type: 'text',
          required: false,
          requiredWith: null,
          notRequiredWith: null,
          min: 2,
          max: 60,
          allowedChars: '.',
          section: 'A',
        },
      },
      identificationNumber: {
        type: 'text',
        required: true,
        requiredWith: null,
        notRequiredWith: null,
        min: 2,
        max: 64,
        allowedChars: '.',
        section: 'B',
      },
      sex: {
        type: 'select',
        required: true,
        requiredWith: null,
        notRequiredWith: null,
        min: 1,
        max: 1,
        allowedChars: '\\b[MmFfOo]{1}',
        section: 'B',
      },
      dateBirth: {
        type: 'date',
        required: true,
        futureAllowed: false,
        section: 'B',
      },
    },
    studyDescription: {
      type: 'text',
      required: false,
      requiredWith: null,
      notRequiredWith: null,
      min: 0,
      max: 64,
      allowedChars: '.',
      section: 'C',
    },
    dateCreated: {
      type: 'date',
      required: true,
      futureNotAllowed: false,
      section: 'C',
    },
    timeCreated: {
      type: 'time',
      required: true,
      section: 'C',
    },
    accessionNumber: {
      type: 'text',
      required: false,
      requiredWith: null,
      notRequiredWith: null,
      min: 0,
      max: 64,
      allowedChars: '.',
      section: 'C',
    },
    requestingPhysician: {
      section: 'requestingPhysician',
      checkPortalSettings: true,
      name: {
        lastName: {
          type: 'text',
          required: false,
          requiredWith: null,
          notRequiredWith: null,
          min: 2,
          max: 60,
          allowedChars: '.',
        },
        firstName: {
          type: 'text',
          required: false,
          requiredWith: null,
          notRequiredWith: null,
          min: 2,
          max: 60,
          allowedChars: '.',
        },
        middleName: {
          type: 'text',
          required: false,
          requiredWith: null,
          notRequiredWith: null,
          min: 2,
          max: 60,
          allowedChars: '.',
        },
        prefix: {
          type: 'text',
          required: false,
          requiredWith: null,
          notRequiredWith: null,
          min: 2,
          max: 60,
          allowedChars: '.',
        },
        suffix: {
          type: 'text',
          required: false,
          requiredWith: null,
          notRequiredWith: null,
          min: 2,
          max: 60,
          allowedChars: '.',
        },
      },
    },
    referringPhysician: {
      section: 'referringPhysician',
      checkPortalSettings: true,
      name: {
        lastName: {
          type: 'text',
          required: false,
          requiredWith: null,
          notRequiredWith: null,
          min: 2,
          max: 60,
          allowedChars: '.',
        },
        firstName: {
          type: 'text',
          required: false,
          requiredWith: null,
          notRequiredWith: null,
          min: 2,
          max: 60,
          allowedChars: '.',
        },
        middleName: {
          type: 'text',
          required: false,
          requiredWith: null,
          notRequiredWith: null,
          min: 2,
          max: 60,
          allowedChars: '.',
        },
        prefix: {
          type: 'text',
          required: false,
          requiredWith: null,
          notRequiredWith: null,
          min: 2,
          max: 60,
          allowedChars: '.',
        },
        suffix: {
          type: 'text',
          required: false,
          requiredWith: null,
          notRequiredWith: null,
          min: 2,
          max: 60,
          allowedChars: '.',
        },
      },
    },
    performingPhysician: {
      section: 'performingPhysician',
      checkPortalSettings: true,
      name: {
        lastName: {
          type: 'text',
          required: false,
          requiredWith: null,
          notRequiredWith: null,
          min: 2,
          max: 60,
          allowedChars: '.',
        },
        firstName: {
          type: 'text',
          required: false,
          requiredWith: null,
          notRequiredWith: null,
          min: 2,
          max: 60,
          allowedChars: '.',
        },
        middleName: {
          type: 'text',
          required: false,
          requiredWith: null,
          notRequiredWith: null,
          min: 2,
          max: 60,
          allowedChars: '.',
        },
        prefix: {
          type: 'text',
          required: false,
          requiredWith: null,
          notRequiredWith: null,
          min: 2,
          max: 60,
          allowedChars: '.',
        },
        suffix: {
          type: 'text',
          required: false,
          requiredWith: null,
          notRequiredWith: null,
          min: 2,
          max: 60,
          allowedChars: '.',
        },
      },
    },
  },
};
